import { EntityConfig } from '@components-fabric';
import {
  ParameterForm,
  getMaterialValidationSchema,
} from '@components-domain/bim';

export const buildingParameterEntity: EntityConfig<any> = {
  id: 'materials',
  columns: ['id', 'name', 'description'],
  endpoints: '/buildingms/categories/parameters',
  name: 'Materials',
  formComponent: ParameterForm,
  schema: getMaterialValidationSchema(),
  empty: {
    creationType: 'RANDOM',
    type: 'TEXT',
    name: '',
    value: '',
    description: '',
    category: 'BUILDING',
  },
};
